import React, { memo, useCallback, useMemo } from 'react';

import { MoreButtonCDS } from '@sharedCR/coreDesignSystem/Buttons';
import { DeleteIcon, EditPenIcon } from '@sharedCR/coreDesignSystem/icons';
import MenuPopoverCDS from '@sharedCR/coreDesignSystem/MenuPopoverCDS';
import PropTypes from 'prop-types';

import { IconSize } from 'constants/coreDesignSystem';
import usePopover from 'hooks/usePopover';

const DocumentRecordActions = ({ row, isEditAllowed, onEdit, onDelete }) => {
  const { anchorEl, onSetAnchorElement, onClearAnchorElement } = usePopover();

  const handleEdit = useCallback(() => {
    onClearAnchorElement();
    onEdit(row);
  }, [onEdit, row, onClearAnchorElement]);

  const handleDelete = useCallback(() => {
    onClearAnchorElement();
    onDelete(row.key);
  }, [onDelete, row.key, onClearAnchorElement]);

  const items = useMemo(
    () => [
      { text: 'Edit', onClick: handleEdit, icon: <EditPenIcon size={IconSize[20]} /> },
      {
        text: 'Delete Document',
        onClick: handleDelete,
        icon: <DeleteIcon size={IconSize[20]} />,
      },
    ],
    [handleEdit, handleDelete],
  );

  return (
    <>
      <MoreButtonCDS
        disabled={!isEditAllowed}
        isSelected={!!anchorEl}
        onClick={onSetAnchorElement}
      />

      <MenuPopoverCDS anchorEl={anchorEl} items={items} onClose={onClearAnchorElement} />
    </>
  );
};

DocumentRecordActions.propTypes = {
  row: PropTypes.shape({
    key: PropTypes.string.isRequired,
  }).isRequired,
  isEditAllowed: PropTypes.bool.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default memo(DocumentRecordActions);
